export default "__VITE_ASSET__DRwzsa2c__"